import each from 'lodash/each'
import * as nodes from './nodes'
import * as edges from './edges'
import * as kinds from './kinds'
import * as bookmarks from './bookmarks'
import * as auth from './auth'
import * as users from './users'
import * as graph from './graph'

type ApiAction = import('types/api').ApiAction
type ApiRequestConfig = import('types/api').ApiRequestConfig


const endpoints = {
  nodes,
  edges,
  kinds,
  bookmarks,
  auth,
  users,
  graph
}

export const formatRequest = (action: ApiAction): ApiRequestConfig => {
  const parts = String(action.meta?.request || '').split('.')
  let req: unknown = endpoints
  each(parts, (p: string) => {
    if (req && typeof req === 'object') {
      req = (req as Record<string, unknown>)[p]
    } else {
      req = undefined
    }
  })
  if (typeof req === 'function') {
    req = (req as (a: ApiAction) => ApiRequestConfig)(action)
  }
  const fallback = { url: '' }
  if (!req || typeof req !== 'object') {
    return fallback
  }
  return req as ApiRequestConfig
}
